import { default as Company } from '.'
import { PageLayout } from '../../../common/app'
import { RouteObject } from 'react-router-dom'
import SettingsIcon from '@mui/icons-material/Settings'
import RevenueGroupsIcon from '@mui/icons-material/Sell'
import ConnectionsIcon from '@mui/icons-material/CloudQueue'

const basePath = '/settings/company'

const sideNavItems = [
  {
    label: 'Settings',
    Icon: SettingsIcon,
    path: `${basePath}/settings`,
  },
  {
    label: 'Revenue Groups',
    Icon: RevenueGroupsIcon,
    path: `${basePath}/revenue-groups`,
  },
  {
    label: 'Connections',
    Icon: ConnectionsIcon,
    path: `${basePath}/connections`,
  },
]

export const companyRoutes: RouteObject[] = [
  {
    path: `${basePath}/settings`,
    element: (
      <PageLayout
        title="Settings"
        sideNavItems={sideNavItems}
        displayLeftTitle={false}
      >
        <Company.Preferences.Component />
      </PageLayout>
    ),
    loader: Company.Preferences.Loader,
  },
  {
    path: `${basePath}/revenue-groups`,
    element: (
      <PageLayout
        title="Revenue Groups"
        sideNavItems={sideNavItems}
        displayLeftTitle={false}
      >
        <Company.RevenueGroups.Component />
      </PageLayout>
    ),
    loader: Company.RevenueGroups.Loader,
  },
  {
    path: `${basePath}/connections`,
    element: (
      <PageLayout
        title="Connections"
        sideNavItems={sideNavItems}
        displayLeftTitle={false}
      >
        <Company.Connections.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Loader,
  },
  {
    path: `${basePath}/connections/square`,
    element: (
      <PageLayout
        title="Connect Square"
        sideNavItems={sideNavItems}
        displayLeftTitle={false}
      >
        <Company.Connections.Square.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Square.Loader,
  },
  {
    path: `${basePath}/connections/xero`,
    element: (
      <PageLayout
        title="Connect Xero"
        sideNavItems={sideNavItems}
        displayLeftTitle={false}
      >
        <Company.Connections.Xero.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Xero.Loader,
  },
]
